import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import ProductSidebar from 'components/ProductSidebar';
import BenefitsCards from 'components/BenefitsCards';
import {
    fetchCropNutritionPageCrops,
    fetchCropNutritionDetail,
    selectCropNutritionDetail,
    selectCropNutritionPageCrops,
    selectCropNutritionDetailIsLoading,
} from 'store/slices/CropNutritionSlice';
import { useNavigate, useParams } from 'react-router-dom';
import GeneralInfoBox from 'components/GeneralInfoBox';
import { type_nutrition } from 'api/constants';
import { ROUTES } from 'constants/routes';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';
import { useAnimation } from 'hooks/useAnimation';
import Preloader from 'Layout/Preloader';
import { scrollToSection, with404Page } from 'helpers';

const DetailedOfCropNutrition = () => {
    const dispatch = useDispatch();
    const { slug } = useParams();
    const navigate = useNavigate();
    const {
        title,
        fs_view_button,
        fs_background,
        purpose_processing,
        detailed_data,
        sidebar_text,
        purposes = [],
    } = useSelector(selectCropNutritionDetail);
    const { sidebar_text_crop_nutrition } = useSelector(selectTranslations);
    const crops = useSelector(selectCropNutritionPageCrops);
    const loading = useSelector(selectCropNutritionDetailIsLoading);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCropNutritionPageCrops({ type: type_nutrition, all: true }));
        with404Page(
            // @ts-ignore
            dispatch(fetchCropNutritionDetail({ slug, type: type_nutrition })),
            navigate,
        );
    }, [dispatch, slug]);

    const handleClick = () => scrollToSection('this');

    const container = useRef();

    useAnimation({
        items: ['.box', '.product-sidebar'],
        container,
        dependencies: [loading],
    });

    if (loading) return <Preloader />;

    return (
        <div ref={container}>
            <Banner title={title} image={fs_background} buttonText={fs_view_button} onClickButton={handleClick} />
            <section className="container this">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={
                        <ProductSidebar
                            baseRoute={ROUTES.cropNutritionPrograms}
                            title={sidebar_text_crop_nutrition || sidebar_text}
                            data={crops}
                        />
                    }
                >
                    <GeneralInfoBox>
                        <div dangerouslySetInnerHTML={{ __html: detailed_data }} />
                        {purpose_processing && <h3>{purpose_processing}</h3>}
                        {!!purposes?.length && <BenefitsCards data={purposes} withCustomContent />}
                    </GeneralInfoBox>
                </WithSidebar>
            </section>
        </div>
    );
};

export default DetailedOfCropNutrition;
